import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/forms";

const { actions, types } = createActions({
  setValidationErrors: ["errors"],
  clearValidationErrors: [],
});

const reducer = createReducer(initialState, {
  [types.SET_VALIDATION_ERRORS]: (state, { payload }) => ({
    ...state,
    validationErrors: payload.errors,
  }),
  [types.CLEAR_VALIDATION_ERRORS]: (state) => ({
    ...state,
    validationErrors: null,
  }),
});

export { reducer as default, types, actions };
